(ns hai.sharing.helper
  "Sharing/permissions helper functions. Some are temporary and have accumulated as the functionality has been rolled out."
  (:require
   [hai-model.model :as model]
   [hai.ui.rf-sugar :refer [defevent-fx defsub]]
   [hai.entity.helpers :as entity]))

;; Entity helper fns

(defn owner?
  "Whether the requester is the entity's explicit owner (`:entity/owner`,
   notes and tasks). Ownership lives outside the share groups, so it is the
   first branch of every check below and, on its own, the only thing that
   unlocks Delete."
  [entity]
  (boolean (:user.entity/owner? entity)))

(defn can-edit?
  [entity]
  (or (:entity/new? entity)
      (owner? entity)
      (some #{:permission.type/admin
              :permission.type/update}
            (:user.entity/permissions entity))))

(defn can-view?
  [entity]
  (or (owner? entity)
      (some model/visibility-permissions (:user.entity/permissions entity))))

(defn can-share?
  "Sharing and role changes: the owner or an admin. A contributor (update)
   edits the entity but does not hand out access."
  [entity]
  (or (owner? entity)
      (some #{:permission.type/admin} (:user.entity/permissions entity))))

(defn can-delete?
  "Delete for entities that have no explicit owner (prompts, mini-apps, …).
   Notes and tasks gate Delete on `owner?` instead: an admin edits and shares
   them, only the owner deletes."
  [entity]
  (some #{:permission.type/admin
          :permission.type/delete}
        (:user.entity/permissions entity)))

(defn can-administer?
  "Admin and nothing less — the level `assert-tags-owned!` demands before a tag
   group may be attached or detached. Update rights on an entity say nothing
   about the tags hanging off it."
  [entity]
  (or (owner? entity)
      (some #{:permission.type/admin} (:user.entity/permissions entity))))

(defn- db->routed-uuid
  [db]
  (get-in db [:routing/current-route :path-params :uuid]))

;; TODO Temporary
;; Evgheni and Donavan: AAAAAAAAHHHHHHHHHH!!!!
(defn ->uuid
  [entity]
  (or
   ;; Used for current prompt share page
   (:uuid entity)
   (entity/->uuid entity)))

;; TODO Temporary
(defn ->type
  [entity]
  (or (or
       ;; Table
       (and (:ai-prompt/uuid entity)
            "ai-prompts")
       (and (:ai-model-config/uuid entity)
            "ai-model-configs")
       ;; Sharing page
       (and (:title entity)
            (:content entity)
            "ai-prompts"))
      ;; Table
      (and (:user/uuid entity)
           "users")
      (throw (ex-info "->type conversion failed" {:entity entity}))))

;; TODO Temporary
(defn ->singular-type
  [entity]
  (or
   ;; Table
   (and (:ai-prompt/uuid entity)
        "ai-prompt")
   (and (:ai-model-config/uuid entity)
        "ai-model-config")
   (and (:connection/uuid entity)
        "connection")
   (and (:mini-app/uuid entity)
        "mini-app")
   (and (:group/uuid entity)
        "group")
   ;; Sharing page
   (and (:title entity)
        (:content entity)
        "ai-prompt")
   (throw (ex-info "->singular-type conversion failed" {:entity entity}))))

(defn entity-route
  ([type {:keys [uuid]}]
   (str "/share/" type "/" uuid))
  ([entity]
   (str "/share/" (->singular-type entity) "/" (->uuid entity))))

(def entity->api-route (comp entity-route :uuid))

(defn entity-shares-route
  [entity]
  (str "/assistant/v0/" (->type entity) "/" (->uuid entity) "/shares"))

(defevent-fx :entity.shares/read
  [_ {:keys [entity]}]
  {:fetch {:url (entity-shares-route entity)
           :store-in [:shares]}})

(defevent-fx :entity.shares/publish
  [_ {:keys [entity on-success-fx]}]
  {:fetch (merge
           {:url (entity-route entity)
            :method :put
            :body {:scope "published"
                   :levels ["permission.type/read"]}}
           (when on-success-fx
             {:on-success-fx on-success-fx}))})

(defevent-fx :entity.shares/unpublish
  [_ {:keys [entity on-success-fx]}]
  {:fetch (merge
           {:url (entity-route entity)
            :method :delete
            :body {:scope "published"
                   :levels ["permission.type/read"]}}
           (when on-success-fx
             {:on-success-fx on-success-fx}))})

(defevent-fx :entity.shares/delete
  [_
   ;; TODO hardcoded type
   {:keys [user entity type permission on-success]
    :as args
    :or {on-success []}}]
  {:fetch {:url (entity-route entity)
           :body {:owners [["user/uuid" (str (:user/uuid user))]]
                  ;; TODO sort out levels coercion with Malli
                  :levels [(str (namespace permission) "/" (name permission))]}
           :method :delete
           :on-success-fx on-success}})

(defsub :routed-prompt-shares
  [db]
  (get-in db [:shares]))
